import { brightspotConfig, getBrightspot5UploadUri } from '../../config'

export default function getConfig() {
  return brightspotConfig.api
}

// Picks the upload host the same way ApolloProviders picks the API host
export function getUploadConfig(brightspot5IsOn) {
  const { upload } = getConfig()
  const brightspot5UploadUri = brightspot5IsOn && getBrightspot5UploadUri()
  return brightspot5UploadUri ? { ...upload, url: brightspot5UploadUri } : upload
}
